import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { PositionProvider } from "../../../context/PositionContext";

export const Embassy = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};

export const AddEmbassy = () => {
  return (
    
      
        <Add />
      
    
  );
};

export const EditEmbassy = () => {
  return (
    
      
        <Edit />
      
    
  );
};
